<template>
    <section class="main">
        <div v-show="isObjectLoading">
            <v-page-loading />
        </div>
        <div v-show="!isObjectLoading">
            <v-page-header :title="isViewMethod ? $t('account.profile') : $t('account.profile.update')" />

            <div class="grid-container">
                <div class="grid-x">
                    <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                        <v-action-buttons :items="getActionButtons" :isDisabled="objectFormDisabled" @actionClicked="onClickAction" />

                        <v-form-message
                            type="error"
                            id="form-error"
                            :message="objectError"
                            :autoCloseTimeout="1500"
                            @onClickAction="onClickActivateDialogAction" />

                        <v-form-message
                            type="success"
                            id="form-success"
                            :message="objectSuccess"
                            :autoCloseTimeout="1000"
                            @onClickAction="onClickActivateDialogAction" />

                        <!-- <div class="box">
                            <div
                                class="form-group"
                                :class="{
                                    'form-group--error': $v.object.hasAcceptedUserTracking.$error
                                }">
                                    <v-account-form-activity-tracking
                                        :key="object.id"
                                        v-model="$v.object.hasAcceptedUserTracking.$model"
                                        :hasError="$v.object.hasAcceptedUserTracking.$error"
                                    />
                            </div>
                        </div> -->
                        <div class="box">
                            <div class="form-block">
                                <div v-if="isViewMethod" class="form-group">
                                    <label>{{ $t('form.account.salutation') }}</label>
                                    <div class="form-control form-control--static">
                                        {{ object.profile.salutation }}
                                    </div>
                                </div>
                                <div v-else class="form-group">
                                    <label for="form-field-salutation">{{ $t('form.account.title') }}</label>
                                    <select id="form-field-salutation" name="salutation" class="form-control form-control--select" v-model="object.profile.salutation">
                                        <option value="">-</option>
                                        <template v-for="title in $helpers.titles">
                                            <option>{{ title }}</option>
                                        </template>
                                    </select>
                                </div>
                                <div v-if="isViewMethod" class="form-group">
                                    <label>{{ $t('form.account.firstname') }}</label>
                                    <div class="form-control form-control--static">
                                        {{ object.profile.firstname }}
                                    </div>
                                </div>
                                <div v-else class="form-group" :class="{ 'form-group--error' : $v.object.profile.firstname.$error, 'form-group--required' : $v.object.profile.firstname.$params.required }">
                                    <label for="form-field-firstname">{{ $t('form.account.firstname') }}</label>
                                    <input type="text" id="form-field-firstname" name="firstname" class="form-control" :placeholder="$t('form.account.firstname.plc')" v-model="$v.object.profile.firstname.$model" />
                                </div>
                                <div v-if="isViewMethod" class="form-group">
                                    <label>{{ $t('form.account.lastname') }}</label>
                                    <div class="form-control form-control--static">
                                        {{ object.profile.lastname }}
                                    </div>
                                </div>
                                <div v-else class="form-group" :class="{ 'form-group--error' : $v.object.profile.lastname.$error, 'form-group--required' : $v.object.profile.lastname.$params.required }">
                                    <label for="form-field-lastname">{{ $t('form.account.lastname') }}</label>
                                    <input type="text" id="form-field-lastname" name="lastname" class="form-control" :placeholder="$t('form.account.lastname.plc')" v-model="$v.object.profile.lastname.$model" />
                                </div>
                                <div v-if="isViewMethod" class="form-group">
                                    <label>{{ $t('form.account.gender') }}</label>
                                    <div class="form-control form-control--static">
                                        {{ $t('gender_' + object.profile.gender) }}
                                    </div>
                                </div>
                                <div v-else class="form-group">
                                    <label for="form-field-gender">{{ $t('form.account.gender') }}</label>
                                    <select id="form-field-gender" name="gender" class="form-control form-control--select" v-model="object.profile.gender">
                                        <option value="2">{{ $t('gender_2') }}</option>
                                        <option value="0">{{ $t('gender_0') }}</option>
                                        <option value="1">{{ $t('gender_1') }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="box">
                            <div class="form-block">
                                <div class="form-group">
                                    <label for="form-field-email">{{ $t('form.account.email') }}</label>
                                    <div class="form-control form-control--static">
                                        {{ object.profile.communication.email }}
                                    </div>
                                </div>
                                <p class="form-help">
                                    <router-link :to="{ name : 'account-update-email' }" :title="$t('form.account.change_email')">
                                        {{ $t('form.account.change_email') }}
                                    </router-link>
                                </p>
                                <div v-if="isViewMethod" class="form-group">
                                    <label>{{ $t('form.phone') }}</label>
                                    <div class="form-control form-control--static">
                                        {{ object.profile.communication.phone }}
                                    </div>
                                </div>
                                <div v-else class="form-group">
                                    <label for="form-field-phone">{{ $t('form.phone') }}</label>
                                    <input type="tel" id="form-field-phone" name="phone" class="form-control" :placeholder="$t('form.phone.plc')" v-model="object.profile.communication.phone" />
                                </div>
                                <div v-if="isViewMethod" class="form-group">
                                    <label>{{ $t('form.mobile') }}</label>
                                    <div class="form-control form-control--static">
                                        {{ object.profile.communication.mobile }}
                                    </div>
                                </div>
                                <div v-else class="form-group">
                                    <label for="form-field-mobile">{{ $t('form.mobile') }}</label>
                                    <input type="tel" id="form-field-mobile" name="mobile" class="form-control" :placeholder="$t('form.mobile.plc')" v-model="object.profile.communication.mobile" />
                                </div>
                            </div>
                        </div>

                        <div class="box">
                            <div class="form-block">
                                <div class="grid-x grid-margin-x">
                                    <div class="cell large-4">
                                        <div v-if="isViewMethod" class="form-group">
                                            <label>{{ $t('form.account.zipcode') }}</label>
                                            <div class="form-control form-control--static">
                                                {{ object.profile.address.zipcode }}
                                            </div>
                                        </div>
                                        <div v-else class="form-group">
                                            <label for="form-field-zipcode">{{ $t('form.account.zipcode') }}</label>
                                            <input type="text" id="form-field-zipcode" name="phone" class="form-control" :placeholder="$t('form.account.zipcode.plc')" v-model="object.profile.address.zipcode" />
                                        </div>
                                    </div>
                                    <div class="cell large-8">
                                        <div v-if="isViewMethod" class="form-group">
                                            <label>{{ $t('form.account.city') }}</label>
                                            <div class="form-control form-control--static">
                                                {{ object.profile.address.city }}
                                            </div>
                                        </div>
                                        <div v-else class="form-group">
                                            <label for="form-field-city">{{ $t('form.account.city') }}</label>
                                            <input type="text" id="form-field-city" name="city" class="form-control" :placeholder="$t('form.account.city.plc')" v-model="object.profile.address.city" />
                                        </div>
                                    </div>
                                </div>
                                <div class="grid-x grid-margin-x">
                                    <div class="cell large-8">
                                        <div v-if="isViewMethod" class="form-group">
                                            <label>{{ $t('form.account.street') }}</label>
                                            <div class="form-control form-control--static">
                                                {{ object.profile.address.street }}
                                            </div>
                                        </div>
                                        <div v-else class="form-group">
                                            <label for="form-field-street">{{ $t('form.account.street') }}</label>
                                            <input type="text" id="form-field-street" name="street" class="form-control" :placeholder="$t('form.account.street.plc')" v-model="object.profile.address.street" />
                                        </div>
                                    </div>
                                    <div class="cell large-4">
                                        <div v-if="isViewMethod" class="form-group">
                                            <label>{{ $t('form.account.housenumber') }}</label>
                                            <div class="form-control form-control--static">
                                                {{ object.profile.address.housenumber }}
                                            </div>
                                        </div>
                                        <div v-else  class="form-group">
                                            <label for="form-field-housenumber">{{ $t('form.account.housenumber') }}</label>
                                            <input type="text" id="form-field-housenumber" name="housenumber" class="form-control" :placeholder="$t('form.account.housenumber.plc')" v-model="object.profile.address.housenumber" />
                                        </div>
                                    </div>
                                </div>
                                <div v-if="isViewMethod" class="form-group">
                                    <label>{{ $t('form.account.region') }}</label>
                                    <div class="form-control form-control--static">
                                        {{ object.profile.address.region }}
                                    </div>
                                </div>
                                <div v-else class="form-group">
                                    <label for="form-field-region">{{ $t('form.account.region') }}</label>
                                    <input type="text" id="form-field-region" name="region" class="form-control" :placeholder="$t('form.account.region.plc')" v-model="object.profile.address.region" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from '../partials/PageHeader';
    import PageLoading from '../partials/PageLoading';
    import ActionButtons from './../partials/Foundation/ActionButtons';
    import FormMessage from './../partials/Forms/FormMessage';
    // import AccountFormActivityTracking from './AccountAcceptActivityTrackingForm.vue';
    import { required, sameAs } from 'vuelidate/lib/validators';

    export default {
        data() {
            return {
                objectLoading           : false,
                objectError             : null,
                objectSuccess           : null,
                objectFormDisabled      : false,
                object                  : {
                    id                      : 0,
                    // hasAcceptedUserTracking: false,
                    profile                 : {
                        firstname           : '',
                        lastname            : '',
                        salutation          : '',
                        gender              : '',
                        links               : [],
                        address             : {
                            city                : '',
                            zipcode             : '',
                            street              : '',
                            region              : '',
                            housenumber         : '',
                            country_code        : ''
                        },
                        communication       : {
                            email               : '',
                            mobile              : '',
                            phone               : ''
                        }
                    }
                }
            }
        },
        components : {
            vPageHeader         : PageHeader,
            vPageLoading        : PageLoading,
            vActionButtons      : ActionButtons,
            vFormMessage        : FormMessage,
            // vAccountFormActivityTracking: AccountFormActivityTracking,
        },
        computed : {
            isViewMethod : function () {
                return this.$route.meta.method === 'view';
            },
            isUpdateMethod : function () {
                return this.$route.meta.method === 'update';
            },
            isObjectLoading : function () {
                return this.objectLoading;
            },
            getActionButtons : function () {
                var buttons = [];

                if (this.isViewMethod) {
                    buttons.push({
                        action  : 'update',
                        router  : { name : 'account-update-profile' }
                    });
                }

                if (this.isUpdateMethod) {
                    buttons.push('save', {
                        action  : 'cancel',
                        router  : { name : 'account-view-profile' }
                    });
                }

                return buttons;
            }
        },
        watch : {
            '$route' : {
                handler : function () {
                    this.onUpdateObject();
                },
                deep    : true
            },
        },
        created : function () {
            this.onUpdateObject();
        },
        validations : function () {
            return {
                object  : {
                    profile : {
                        firstname : {
                            required
                        },
                        lastname : {
                            required
                        },
                    },
                   /*  hasAcceptedUserTracking: {
                        required,
                        isAccepted: value => value === true,
                    }, */
                }
            };
        },
        methods : {
            onClickAction : function (action) {
                this.objectError    = null;
                this.objectSuccess  = null;

                switch (action) {
                    case 'save':
                        this.onSubmitObject();
                        break;
                }
            },
            onClickActivateDialogAction : function (id, action) {
                this.objectError    = null;
                this.objectSuccess  = null;
            },
            onUpdateObject : function () {
                this.objectLoading = true;

                this.$api
                    .clearParams()
                    .userGetAccount()
                    .then(response => {
                        this.object = response.data.data;
                    })
                    .catch(error => {
                        // TODO: handle error, show user message?
                        console.log(error);
                    })
                    .finally(() => {
                        this.objectLoading = false;
                        this.$v.object.$touch();
                    });
            },
            onSubmitObject : function () {
                this.objectError = null;
                this.objectSuccess = null;
                this.objectFormDisabled = true;

                this.$v.object.$touch();

                if (this.$v.object.$invalid) {
                    this.objectFormDisabled = false;
                    this.objectError = this.$t('form.error_form');
                    return;
                }

                this.$api
                    .clearParams()
                    .userUpdateProfile(this.object)
                    .then(() => {
                        this.objectSuccess = this.$t('account.profile.update.success');
                    })
                    .catch(error => {
                        this.objectError = this.$t(error.response.data.message);
                    }).finally(() => {
                        this.objectFormDisabled = false;
                    });
            }
        }
    }
</script>
